<!--
 * @Author: v_aydwang
 * @Date: 2022-12-21 17:03:12
 * @LastEditors: v_aydwang
 * @LastEditTime: 2022-12-21 17:03:12
 * @Description: 大屏-预警信息弹窗
-->
<template>
  <div id="infoModal" v-if="warnVisible">
    <div class="title">预警信息</div>
    <div class="warning-information">
      <el-table
        :data="tableData"
        border
        v-loading="loading"
        class="table"
        max-height="380"
      >
        <template v-for="item in detailConfig">
          <el-table-column
            :prop="item.prop"
            :label="item.label"
            :key="item.prop"
            :width="item.width || ''"
          >
          </el-table-column>
        </template>
      </el-table>
      <template>
        <div class="pagination">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="pageSize"
            layout="total,prev, pager, next, jumper"
            :total="totalCount"
          ></el-pagination>
        </div>
      </template>
    </div>
    <slot name="close"></slot>
  </div>
</template>

<script>
import { detailConfig } from './const';
export default {
  components: {},
  props: {
    warnVisible: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    warnVisible(newVal) {
      if (newVal) {
        // this.getWorkList();
      }
    },
  },
  data() {
    return {
      tableData: [
        {
          rank: '2022-11-12',
          rate: '2',
          start_time: '差',
          outsourcer: 'A',
          product: '1111',
          operator_name: 'wxd',
        },
        {
          rank: '2022-11-12',
          rate: '2',
          start_time: '差',
          outsourcer: 'A',
          product: '1111',
          operator_name: 'wxd',
        },
        {
          rank: '2022-11-12',
          rate: '2',
          start_time: '差',
          outsourcer: 'A',
          product: '1111',
          operator_name: 'wxd',
        },
        {
          rank: '2022-11-12',
          rate: '2',
          start_time: '差',
          outsourcer: 'A',
          product: '1111',
          operator_name: 'wxd',
        },
        {
          rank: '2022-11-12',
          rate: '2',
          start_time: '差',
          outsourcer: 'A',
          product: '1111',
          operator_name: 'wxd',
        },
        {
          rank: '2022-11-12',
          rate: '2',
          start_time: '差',
          outsourcer: 'A',
          product: '1111',
          operator_name: 'wxd',
        },
        {
          rank: '2022-11-12',
          rate: '2',
          start_time: '差',
          outsourcer: 'A',
          product: '1111',
          operator_name: 'wxd',
        },
        {
          rank: '2022-11-12',
          rate: '2',
          start_time: '差',
          outsourcer: 'A',
          product: '1111',
          operator_name: 'wxd',
        },
        {
          rank: '2022-11-12',
          rate: '2',
          start_time: '差',
          outsourcer: 'A',
          product: '1111',
          operator_name: 'wxd',
        },
        {
          rank: '2022-11-12',
          rate: '2',
          start_time: '差',
          outsourcer: 'A',
          product: '1111',
          operator_name: 'wxd',
        },
        {
          rank: '2022-11-12',
          rate: '2',
          start_time: '差',
          outsourcer: 'A',
          product: '1111',
          operator_name: 'wxd',
        },
        {
          rank: '2022-11-12',
          rate: '2',
          start_time: '差',
          outsourcer: 'A',
          product: '1111',
          operator_name: 'wxd',
        },
        {
          rank: '2022-11-12',
          rate: '2',
          start_time: '差',
          outsourcer: 'A',
          product: '1111',
          operator_name: 'wxd',
        },
        {
          rank: '2022-11-12',
          rate: '2',
          start_time: '差',
          outsourcer: 'A',
          product: '1111',
          operator_name: 'wxd',
        },
        {
          rank: '2022-11-12',
          rate: '2',
          start_time: '差',
          outsourcer: 'A',
          product: '1111',
          operator_name: 'wxd',
        },
        {
          rank: '2022-11-12',
          rate: '2',
          start_time: '差',
          outsourcer: 'A',
          product: '1111',
          operator_name: 'wxd',
        },
        {
          rank: '2022-11-12',
          rate: '2',
          start_time: '差',
          outsourcer: 'A',
          product: '1111',
          operator_name: 'wxd',
        },
        {
          rank: '2022-11-12',
          rate: '2',
          start_time: '差',
          outsourcer: 'A',
          product: '1111',
          operator_name: 'wxd',
        },
      ],
      loading: false,
      detailConfig,
      currentPage: 1, // 第几页
      pageSize: 6, // 每页有多少
      totalCount: 15,
    };
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val;
      this.queryParams.pageNo = this.currentPage;
      this.getTableData();
    },

  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/convert-viewport";
#infoModal {
  position: absolute;
  padding: vw(20) vh(28);
  top: vh(352);
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: vw(1280);
  height: vh(680);
  background-image: linear-gradient(
    179deg,
    rgba(224, 236, 255, 0.9) 0%,
    rgba(202, 219, 255, 0.9) 100%
  );
  border: 1px solid #ffffff;
  box-shadow: 0 12px 12px 6px rgba(255, 255, 255, 0.16);
  border-radius: 20px;
  z-index: 1;
  .title {
    font-family: TencentSansW7;
    font-size: vw(24);
    color: #165bec;
    letter-spacing: 0;
    text-align: center;
    line-height: vh(36);
  }
  .warning-information {
    margin-top: vh(36);
  }
  .table{
    width: 100%;
  }
  .pagination{
    margin-top: vh(26);
    text-align: right;
  }
}
</style>
<style lang="less" scoped>
/deep/ th {
  background: #cedcf1;
  color: #112A5A;
}
/deep/ tr {
  background: #cadbffc4;
  color:#41557B
}
/deep/ tr:hover>td {
            background-color:#cadbffc4 !important
        }
        /deep/.btn-prev{
          background: #CADBFF !important;
        }
        /deep/.number{
          background: #CADBFF !important;
        }
        /deep/.btn-next{
          background: #CADBFF !important;
        }
        /deep/.el-input__inner{
          background: #CADBFF !important;
          border: 1px solid #FFFFFF;;
        }
</style>
